import createIsSubmitting from './selectors/isSubmitting';
import plain from './structure/plain';

export default createIsSubmitting(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/isSubmitting.js
// module id = 1587
// module chunks = 0